/* eslint-disable import/no-unresolved */
import { Swiper, Navigation } from 'swiper';
import { breakpoints } from '../../../resources/scripts/config/breakpoints';

const SLIDE_SPEED = 500;
const GAP = { base: 24, lg: 32 };

function setNavDisabled(btn, disabled) {
  btn.classList.toggle('disabled', disabled);
  // eslint-disable-next-line no-param-reassign
  btn.disabled = disabled;
  btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
}

function createNavSync(prevEl, nextEl) {
  return (swiper) => {
    setNavDisabled(prevEl, swiper.isBeginning);
    setNavDisabled(nextEl, swiper.isEnd);
  };
}

function initImageSliderRoot(rootEl) {
  const swiperEl = rootEl.querySelector('.image-slider__swiper');
  const prevEl = rootEl.querySelector('.image-slider__nav--prev');
  const nextEl = rootEl.querySelector('.image-slider__nav--next');

  if (!swiperEl || !prevEl || !nextEl) {
    return;
  }

  const updateNav = createNavSync(prevEl, nextEl);
  const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

  if (slideCount <= 1) {
    setNavDisabled(prevEl, true);
    setNavDisabled(nextEl, true);
    return;
  }

  swiperEl.swiper?.destroy(true, true);

  // eslint-disable-next-line no-new -- instance is stored on swiperEl.swiper
  new Swiper(swiperEl, {
    modules: [Navigation],
    slidesPerView: 'auto',
    spaceBetween: GAP.base,
    loop: false,
    grabCursor: true,
    watchOverflow: true,
    speed: SLIDE_SPEED,
    breakpoints: {
      [breakpoints.lg]: { spaceBetween: GAP.lg },
    },
    navigation: { prevEl, nextEl },
    on: {
      init: updateNav,
      resize: updateNav,
      slideChange: updateNav,
      fromEdge: updateNav,
    },
  });
}

function initAllImageSliders() {
  document.querySelectorAll('.image-slider').forEach(initImageSliderRoot);
}

document.addEventListener('DOMContentLoaded', () => {
  initAllImageSliders();

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-image-slider', initAllImageSliders);
  }
});
